// extracted by mini-css-extract-plugin
export var container = "Caption-module--container--oBhvn";
export var small = "Caption-module--small--aTwvx";
export var compact = "Caption-module--compact--meolf";
export var textContainer = "Caption-module--textContainer--Jfktq";